import ReactGA from 'react-ga4';

import InputBase from '@mui/material/InputBase';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    searchBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: '10px',
        boxShadow: '0px 8px 16px 4px #0000000D',
        height: 'auto',
        padding: '16px 24px',
        width: '100%',
    },
    iconContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        width: '100%',
        '& .MuiInputBase-root': {
            width: '100%'
        }
    },
    searchIcon: {
        color: '#A6A6BF',
        pointerEvents: 'none'
    },
    cancelIcon: {
        color: '#7378E8',
        cursor: 'pointer',
        '&:active': {
            transform: 'scale(0.9)'
        }
    }
}));

type SearchBarProps = {
    empty: boolean;
    query: string;
    setQuery: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const SearchBar: React.FC<SearchBarProps> = ({
    empty,
    query,
    setQuery
}) => {
    const classes = useStyles();

    const handleSearchBarClick = () => {
        ReactGA.event({
            category: 'Navigation',
            action: 'Click',
            label: 'Search Membber Bar'
        });
    };

    return (
            <div className={classes.searchBar}>
                <div className={classes.iconContainer}>
                    <div className={classes.searchIcon}>
                        <i className={'far fa-search'} />
                    </div>
                    <InputBase
                        disabled={empty}
                        id="search-bar-input"
                        inputProps={{
                            'aria-label': 'find your member'
                        }}
                        onChange={setQuery}
                        onClick={handleSearchBarClick}
                        placeholder="Find your member"
                        aria-label="find your member"
                        value={query}
                    />
                </div>
                {query && query.length && (
                    <div
                        className={classes.cancelIcon}
                        onClick={() => setQuery({ target: { value: '' } } as React.ChangeEvent<HTMLInputElement>)}
                    >
                        <i className={'fas fa-times'} />
                    </div>
                )}
            </div>
    );
};

export default SearchBar;
